export default __webpack_public_path__ + "static/media/FFA500.0a75d044.svg";